



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { cloneDeep, isEqual } from 'lodash'

@Component
export default class CreatePhaseStatusFormStep4 extends Vue {
    @Prop({ required: true }) readonly value!: RealworksStatusRule
    editingValue: RealworksStatusRule = null

    @Watch('value', { immediate: true })
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
    }

    @Watch('editingValue.comment')
    @Watch('editingValue.notifyAssignedTo')
    @Watch('editingValue.active')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }

    get avatarHeaderText() {
        return this.$t('virtualColleague.phaseStatus.avatarHeader.stepFour',
            {
                applyToTriggeredReferrals: this.applyToTriggeredReferrals,
                triggerType: this.triggerType,
                applyToTriggeredReferralsPastDays: this.value.applyToTriggeredReferralsPastDays,
            },
        )
    }

    get applyToTriggeredReferrals() {
        if (this.value.applyToTriggeredReferrals === true) {
            return 'toe'
        } else {
            return 'niet toe'
        }
    }

    get triggerType() {
        if (this.value.triggerType === 'agendaTypes') {
            return 'afspraken'
        } else if (this.value.triggerType === 'taakTypes') {
            return 'taken'
        } else {
            return 'kenmerken'
        }
    }
}
